import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import { InputField } from "components/InputField";
import { MyCheckbox } from "components/MyCheckbox";
import { Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import AccountsTypesView from "../AccountsTypesView/AccountsTypesView";
const AccountTypesEdit = ({
  type,
  edit,
  updateFunc,
  formik,
  addNew,
  createFunc,
  setEdit,
  setDaisableAddNew,
  setDisable,
  setAddNew,
  disable,
}) => {
  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const { push } = useHistory();
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  useEffect(() => {
    if (disable === false) {
      push({
        pathname: "/financial-setting/members/account-types/view",
      });
    }
  });
  const handleCancel = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();
    formik.resetForm();
    push({
      pathname: "/financial-setting/members/account-types/view",
    });
  };
  const cancelFunc = () => {
    setOpenDisableAlert(true);
  };
  const validateCreateFunc = () => {
    if (!formik.values?.new_catagory_type) {
      return toastr.info("Validation", "Text field is mandatory");
    }
    if (
      !(
        formik.values?.catagory_is_organization === true ||
        formik.values?.catagory_is_member === true ||
        formik.values?.catagory_is_not_member === true
      )
    ) {
      return toastr.info(
        "Validation",
        "You should select at least one account type!"
      );
    }

    createFunc();
    push({
      pathname: "/financial-setting/members/account-types/view",
    });
  };
  const validateUpdate = () => {
    updateFunc();
    push({
      pathname: "/financial-setting/members/account-types/view",
    });
  };
  return (
    <>
      <div className="accounts-type-checkboxes">
        <AccountsTypesView edit={edit} formik={formik} addNew={addNew} />
      </div>
      <div className="d-flex justify-content-end p-5">
        <AlertDialog
          open={openDisableAlert}
          handleClose={handleCloseDialog}
          onDecline={() => {
            setOpenDisableAlert(false);
          }}
          onAccept={handleCancel}
          title={" Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
        <Button 
          onClick={cancelFunc}
          variant="primary-outline"
          size="md"
          style={{ minWidth: 80 }}
        >
          Cancel
        </Button>
        <Button
          className="ml-5"
          onClick={
            edit === true
              ? validateUpdate
              : addNew === true
              ? validateCreateFunc
              : ""
          }
          variant="primary"
          size="md"
          style={{ minWidth: 80 }}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default AccountTypesEdit;
